module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "dedic1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("For Sofia, who first sang the song—")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "dedic"
  }, [_vm._v("For Nicky, who sings it too.")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Love,")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("P. M.")])])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d39b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 57
// module chunks = 0